import RideSolvedResponse, {
  RideSolvedResponseRideSolvedWaypoint,
  RideSolvedResponseRideSolvedWaypointMeta,
} from "../../../api/raily/ride/solved/ride-solved.response";
import RideSolved, {
  RideSolvedRideSolvedWaypoint,
  RideSolvedRideSolvedWaypointMeta,
} from "./ride-solved";

const createWaypointMeta = (
  meta: RideSolvedResponseRideSolvedWaypointMeta
): RideSolvedRideSolvedWaypointMeta => {
  return {
    estimatedTime: meta.estimatedTime,
    id: meta.id,
  };
};

const createWaypoint = (
  seq: RideSolvedResponseRideSolvedWaypoint
): RideSolvedRideSolvedWaypoint => {
  return {
    meta: createWaypointMeta(seq.meta),
  };
};

const createWaypoints = (
  seq: RideSolvedResponseRideSolvedWaypoint[]
): RideSolvedRideSolvedWaypoint[] => {
  return seq.map(createWaypoint);
};

const create = (response: RideSolvedResponse): RideSolved => {
  return {
    seq: createWaypoints(response.data.seq),
  };
};

const rideSolvedFactory = {
  create,
};

export default rideSolvedFactory;
